import React from "react";
import AuthManager from "Common/AuthManager";
import LoadingSuccessErrorAlertRerun from "Components/Common/LoadingSuccessErrorAlertRerun";
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { LOADING, SUCCESS, ERROR } from "../ProductConstants";
import RulesReRunTableData from "./RuleRerunTableData";


type MyProps = {
    rulesRerun: boolean,
    setRulesRerun: Dispatch<SetStateAction<boolean>>
    catId: string
}

type RuleItem = {
    id: string
    name: string
    type: string
    status: string|boolean
  }

function RulesReRun({ rulesRerun, setRulesRerun, catId } : MyProps) {
    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    const [Loading, setLoading] = useState<{status: string, message?: string}>({
      status: "",
      message: "",
    });
    const [rulesObj, setRulesObj] = useState<RuleItem[]>([]);
    const [showClose, setShowClose] = useState(true);
    const [minimize, setMinimize] = useState(false)
  
    useEffect(() => {
      get_rules();
    }, []);
   
    async function get_rules() {
      setLoading({
        status: "Loading",
        message: "Loading all the rules to rerun",
      });
  
      let res = await ServiceWrapper.doGet(
        `${api_base_url}category/${catId}/associatedrulesforrerun/list`,
        null,
        null,
        AuthManager.getGmsToken()
      );
      if (!res.errorfound) {
        if (res.data.done) {
          let ruleList = res.data.data;
          let arr: RuleItem[]= [];
          ruleList.map((rule: any, index: number) => {
            return arr.push({
              id: rule.id,
              name: rule.name,
              type: rule.type,
              status: false,
            });
          });
          if (arr.length > 0) {
            setRulesObj([...arr]);
          } else {
            setShowClose(false);
          }
  
          setLoading({
            status: "Success",
            message: undefined,
          });
        } else {
          setLoading({
            status: "Error",
            message: res.data.message,
          });
        }
      } else {
        setLoading({
          status: "Error",
          message: "Error while Loading rules, Please try after some time.",
        });
      }
      setTimeout(() => {
        if (Loading.status !== "Success")
          setLoading({
            status: "",
            message: "",
          });
      }, 5000);
    }
  
    const updateState = (RuleId: string, status: string, nextItem: string, nextStatus: string) => {
      setRulesObj(
        rulesObj.map((item) => {
          if (item.id === RuleId) {
            return { ...item, status: status };
          } else if (item.id === nextItem) {
            return { ...item, status: nextStatus };
          } else {
            return item;
          }
        })
      );
  
      if (
        rulesObj[rulesObj.length - 1].status !== false ||
        rulesObj.length === 1
      ) {
        setShowClose(false);
      }
    };
  
    function getRuleRow(item: RuleItem, index: number) {
      let nextItem;
      if ((index === 0 && item.status === false) || item.status === LOADING) {
        if (index < rulesObj.length - 1) {
          nextItem = rulesObj[index + 1].id;
        } else {
          nextItem = null;
        }
        return (
          <RulesReRunTableData
            RuleId={item.id}
            // RuleName={item.name}
            key={index}
            nextItem={nextItem}
            updateState={updateState}
            // setShowClose={setShowClose}
          />
        );
      } else if (item.status === SUCCESS) {
        return (
          <div className="tw-w-10 px-2">
            <span className="tw-block tw-aspect-square tw-w-2 tw-h-2 tw-mt-1.5 tw-rounded-full tw-bg-success tw-m-auto"/>
          </div>
        );
      } else if (item.status === ERROR) {
        return (
          <div className="tw-w-10 px-2">
            <span className="tw-block tw-aspect-square tw-w-2 tw-h-2 tw-mt-1.5 tw-rounded-full tw-bg-danger tw-m-auto"/>
          </div>
        );
      } else if (item.status === false) {
        return (
          <div className="tw-w-10 px-2">
            <i className="fas fa-spinner tw-text-slategray tw-m-auto"></i>
          </div>
        );
      }
    }
  
    return (
        <div 
          className={`tw-fixed ${minimize ? 'tw-right-0' : "tw-right-5"} tw-bottom-5  tw-bg-white 
          tw-z-10 tw-shadow-md tw-rounded-md tw-border`}
        >
            <div className="tw-flex tw-items-center tw-justify-between tw-px-2 tw-mt-3">
              {!minimize && <h5 className="tw-text-left tw-font-semibold tw-text-sm">Adding products to rules</h5>}
              <div className={`tw-flex tw-items-center tw-space-x-3 ${!minimize && "tw-ml-8"}`}>
                <button 
                type="button" 
                onClick={() => setMinimize((prev) => !prev)}
                className="tw-p-2 tw-bg-gray tw-rounded-full tw-aspect-square tw-w-6 
                tw-h-6 tw-flex tw-items-center  tw-justify-center">
                  <i className={`fa ${!minimize ? "fa-angle-double-right" : "fa-angle-double-left"} tw-text-slategray`}></i>
                </button>
                {
                  !minimize &&
                  <button type="button" 
                  onClick={() => setRulesRerun(false)}
                  className="tw-p-2 tw-bg-gray tw-rounded-full tw-aspect-square tw-w-6 
                  tw-h-6 tw-flex tw-items-center  tw-justify-center">
                    <i className="fa fa-times tw-text-slategray"></i>
                  </button>
                }
              </div>
            </div>
            <div className="tw-max-h-[200px] tw-overflow-auto">
              {!minimize && <LoadingSuccessErrorAlertRerun loading={Loading} handle_reload={undefined} />}
              {rulesObj &&
                (rulesObj.length > 0 ? (
                  <>
                    <div>
                      <ul className="tw-text-left tw-text-xs">
                        {rulesObj.map((item, index) => {
                          return (
                            <li key={index} className="tw-flex tw-border-b py-2">
                              {getRuleRow(item, index)}
                              {
                                !minimize && 
                                <div>
                                  <p className="tw-font-semibold">{item.name}</p>
                                  <p>{item.type}</p>
                                </div>
                              }
                            </li>
                            );
                          })}
                          <li>
                          
                        </li>
                      </ul>
                    </div>
                  </>
                ) : (
                  <>
                    {Loading.status !== "Loading" && (
                      <div
                        className="alert alert-primary bg-white small p-2"
                        role="alert"
                      >
                        <strong>No rules found for rerun</strong>
                      </div>
                    )}
                  </>
                ))}
              {/*<p>Modal body text goes here.</p>*/}
            </div>
            {/* <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                disabled={showClose}
                data-dismiss="modal"
                onClick={() => setRulesRerun(false)}
              >
                Close
              </button>
            </div> */}
          </div>
    );
  }

export default RulesReRun

